import Vue from 'vue';
import Vuex from 'vuex';
import {STORE as MAPPINGS_STORE, PREFIX as MAPPINGS_PREFIX} from './modules/mappings.js';
import {STORE as APP_STORE, PREFIX as APP_PREFIX} from './modules/app.js';
import {STORE as HIERARCHY_STORE, PREFIX as HIERARCHY_PREFIX} from './modules/hierarchy.js';
import {STORE as FIELDS_MAPPING_STORE, PREFIX as FIELDS_MAPPING_PREFIX} from './modules/fieldsMapping.js';
import {STORE as SMTP_CONFIGURATION_STORE, PREFIX as SMTP_CONFIGURATION_PREFIX} from './modules/smtpConfiguration.js';
import {STORE as LOGGING_EVENTS_STORE, PREFIX as LOGGING_EVENTS_PREFIX} from './modules/loggingEvents.js';
import {STORE as SUPPORT_ACTIVITY_STORE, PREFIX as SUPPORT_ACTIVITY_PREFIX} from './modules/supportActivity.js';
import {STORE as USERS_MAPPING_STORE, PREFIX as USERS_MAPPING_PREFIX} from './modules/usersMapping.js';
import profileFilters from './modules/profileFilters.js';
import migration from './modules/migration.js';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		[MAPPINGS_PREFIX]: MAPPINGS_STORE,
		[HIERARCHY_PREFIX]: HIERARCHY_STORE,
		[APP_PREFIX]: APP_STORE,
		[FIELDS_MAPPING_PREFIX]: FIELDS_MAPPING_STORE,
		[SMTP_CONFIGURATION_PREFIX]: SMTP_CONFIGURATION_STORE,
		[LOGGING_EVENTS_PREFIX]: LOGGING_EVENTS_STORE,
		[SUPPORT_ACTIVITY_PREFIX]: SUPPORT_ACTIVITY_STORE,
        [USERS_MAPPING_PREFIX]: USERS_MAPPING_STORE,
        profileFilters,
		migration,
	},
});



// WEBPACK FOOTER //
// ./src/store/index.js